module.exports = __webpack_public_path__ + "static/media/Newt Scamander 1.23090657.jpg";